module.exports = __webpack_public_path__ + "img/scitum-telmex.438fdd1a.svg";